// Copyright (C) Lembani Sakala - All rights reserved.
// Lembani Sakala.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.

import React from 'react';
import { Link } from 'react-router-dom';

import contact from '../../images/cont-us.png';

export const Contact = () => {
  return (
    <section className="contact-section-clean position-relative py-5" style={{ background: 'linear-gradient(120deg, #f8fafc 60%, #e3e8ee 100%)', overflow: 'hidden' }}>
      {/* Larger, more prominent blob */}
      <div style={{
        position: 'absolute',
        top: '-120px',
        right: '-180px',
        width: '400px',
        height: '400px',
        background: 'radial-gradient(circle, #e81f29 0%, #fff0 80%)',
        zIndex: 0,
        opacity: 0.18,
        borderRadius: '50%',
        filter: 'blur(2.5px)'
      }} />
      <div className="container position-relative" style={{zIndex: 2}}>
        <div className="row align-items-center justify-content-center g-5">
          <div className="col-12 col-md-6 order-2 order-md-1 d-flex flex-column align-items-center align-items-md-start">
            <h2 className="fw-bold display-5 mb-3 text-center text-md-start">Get In Touch</h2>
            <p className="lead text-secondary mb-4 text-center text-md-start">
              We'd love to hear from you! Get in touch with us for any inquiries or assistance.
            </p>
            <Link to="/contact" className="btn btn-r btn-lg px-5 py-2 shadow">Contact Us</Link>
          </div>
          <div className="col-12 col-md-5 order-1 order-md-2 d-flex justify-content-center mb-4 mb-md-0">
            <div className="bg-white rounded-4 shadow-sm p-3">
              <img src={contact} className="img-fluid rounded-4" alt="Contact City Drive" style={{maxHeight: 260, objectFit: 'cover'}} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
